/**
 *
 * @description  删除任务关联弹窗
 * @author xiongwei_zhang
 *
 * */

import { forwardRef, useImperativeHandle, useState, useEffect } from 'react';
import { LoadingOutlined } from '@ant-design/icons';
import { Tooltip, Modal, Spin } from 'antd';
import SvgIcon from '&/components/SvgIcon';
import './DelLinkModal.scss';

const DelLinkModal = forwardRef((props, ref) => {
    const { showDate = false, hasEditPrim = true } = props;
    const [isModalOpen, setIsModalOpen] = useState(false);

    const [linkInfo, setLinkInfo] = useState({});

    useEffect(() => {
        linkInfo.position && setIsModalOpen(true);
    }, [linkInfo]);

    const show = info => {
        setLinkInfo(info);
        setIsModalOpen(true);
    };

    useImperativeHandle(ref, () => {
        return { show };
    });

    const [waitting, setWaitting] = useState(false);

    const onDel = async () => {
        setWaitting(true);
        try {
            await props.onDelLink(linkInfo.id);
            setIsModalOpen(false);
            setLinkInfo({});
        } finally {
            setWaitting(false);
        }
    };

    return (
        <Modal
            visible={isModalOpen}
            footer={null}
            width="11.625rem"
            closable={false}
            destroyOnClose
            wrapClassName="link-edit-modal"
            onCancel={() => setIsModalOpen(false)}
            bodyStyle={{ padding: 8 }}
            maskStyle={{ 'background-color': 'transparent' }}
            style={linkInfo.position}>
            <Spin
                spinning={waitting}
                indicator={
                    <LoadingOutlined
                        style={{
                            fontSize: 24,
                        }}
                        spin
                    />
                }>
                <div className="task-wrap">
                    <div className="task-title ">
                        {linkInfo.sourceTask?.name}
                    </div>
                    {showDate && (
                        <div className="task-date">
                            开始日期：{linkInfo.sourceTask?.timeAt}
                        </div>
                    )}
                </div>
                <div className="link-edit">
                    <div className="link-icon-wrap">
                        <SvgIcon iconName="link" />
                    </div>
                    {linkInfo.type > 0 ? '开始之后' : '结束之后'}
                    <Tooltip
                        title={
                            <span style={{ fontSize: '.75rem' }}>取消关联</span>
                        }>
                        <i
                            onClick={hasEditPrim && onDel}
                            className={`pointer outlined icon-Trash${
                                hasEditPrim ? '' : ' type--disabled'
                            }`}></i>
                    </Tooltip>
                </div>
                <div className="task-wrap">
                    <div className="task-title ">
                        {linkInfo.targetTask?.name}
                    </div>
                    {showDate && (
                        <div className="task-date">
                            开始日期：{linkInfo.targetTask?.timeAt}
                        </div>
                    )}
                </div>
            </Spin>
        </Modal>
    );
});

export default DelLinkModal;
